import { ENUM } from '../constants/enum';
import { useNuxtApp } from '#app';

export const isValidResponse = (res: any) => {
  const { $functions } = useNuxtApp();
  if (res?.message === ENUM.API_RESPONSE_MESSAGE.SUCCESS) {
    return true;
  } else {
    if (res?.message === ENUM.API_RESPONSE_MESSAGE.UNAUTHORIZED) {
      // handleLogout();
    }
    $functions.notify.error({
      text: res.message,
    });
    return false;
  }
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isValidPhoneNumber = (phone: string): boolean => {
  const phoneRegex = /^(?:\+66|0)([13452689])\d{8}$/;
  return phoneRegex.test(phone);
};

export const validateNumber = (value: any, defaultvalue: number | null = null): number | null => {
  return isNaN(parseInt(value))
    ? defaultvalue
    : parseInt(value)
};